export default {
  "long": {
    "year": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["numeric"])},
    "month": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["long"])},
    "day": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["numeric"])},
    "weekday": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["long"])},
    "hour": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["numeric"])},
    "minute": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["numeric"])}
  }
}